import axios from 'axios';

/**
 * Service for seat selection modal
 */
export const SeatSelectionService = {
  /**
   * Get event data for seat selection modal
   * Includes ticket types with seats mapping, floor plan info, etc.
   * @param {number} eventId
   * @returns {Promise<Object>} Event data for seat selection
   */
  async getEventForSeatSelection(eventId) {
    return axios.get(`/api/v2/seat-selection/events/${eventId}`);
  },
};
